import {Controller} from '@hotwired/stimulus'

// Base class for client-side name filters over server-rendered lists. Subclasses
// register under their own identifier; Stimulus resolves these targets against the
// registering identifier, so a subclass registered as `agent-search` reads
// data-agent-search-target while inheriting the target names from here.
//
// Not named index.js on purpose: packs/stimulus.js auto-registers every index.js
// under hotwire/controllers/ as a controller named for its parent directory, so an
// index.js here would register a phantom `support` controller.
export default class extends Controller {
  static targets = ['input', 'row']

  connect() {
    this.filter()
  }

  filter() {
    if (!this.hasInputTarget)
      return

    const query = this.inputTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      const name = row.dataset.name || ''
      row.hidden = query !== '' && !name.includes(query)
    })
  }
}
